/**
 * Return a string representing the first part of the route in entity page
 * or entity compare page
 * compareMode string indicating IF and which compareMode we are in
 * countryIds array (optional) if in country compare mode, you need to pass this array
 *
 */
export default (
  compareMode: string | undefined,
  countryIds?: any[] | undefined
): string => {
  if (compareMode) {
    if (compareMode === 'entity') {
      return '/compare/entity';
    } else if (compareMode === 'country') {
      const filteredCountryIds = countryIds
        ? countryIds.filter((cId: string) => !cId.includes('EX'))
        : [];
      return `/compare/country/${
        filteredCountryIds.length > 0 ? filteredCountryIds.join(',') : 'all'
      }/entity`;
    }
  }
  return '/entity';
};
